import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { Fragment } from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
import { customProductIconCSS, customProductLogoCSS, productHomeButtonCSS, siteTitleCSS } from './styles';
import { getTag } from './utils';

var CustomProductHome = function CustomProductHome(props) {
  var iconAlt = props.iconAlt,
      iconUrl = props.iconUrl,
      logoAlt = props.logoAlt,
      logoUrl = props.logoUrl,
      href = props.href,
      onClick = props.onClick,
      siteTitle = props.siteTitle,
      onMouseDown = props.onMouseDown,
      testId = props.testId,
      _props$logoMaxWidth = props.logoMaxWidth,
      logoMaxWidth = _props$logoMaxWidth === void 0 ? 260 : _props$logoMaxWidth,
      rest = _objectWithoutProperties(props, ["iconAlt", "iconUrl", "logoAlt", "logoUrl", "href", "onClick", "siteTitle", "onMouseDown", "testId", "logoMaxWidth"]);

  var theme = useTheme();
  var Tag = getTag(onClick, href);

  var preventFocusRing = function preventFocusRing(event) {
    event.preventDefault();
    onMouseDown && onMouseDown(event);
  };

  return jsx(Fragment, null, jsx(Tag, _extends({
    href: href,
    css: productHomeButtonCSS(theme),
    onClick: onClick,
    onMouseDown: preventFocusRing,
    "data-testid": testId && "".concat(testId, "-container")
  }, rest), logoUrl && jsx("img", {
    css: customProductLogoCSS(logoMaxWidth),
    src: logoUrl,
    alt: logoAlt,
    "data-testid": testId && "".concat(testId, "-logo")
  }), iconUrl && jsx("img", {
    css: customProductIconCSS,
    src: iconUrl,
    alt: iconAlt,
    "data-testid": testId && "".concat(testId, "-icon")
  })), siteTitle && jsx("div", {
    css: siteTitleCSS(theme),
    "data-testid": testId && "".concat(testId, "-site-title")
  }, siteTitle));
};

export default CustomProductHome;